export default __webpack_public_path__ + "static/media/img_17.a6372d3c.webp";